/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-09 17:51:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-09 13:40:36
 */
import Vue from "vue";
import VueRouter from "vue-router";
import login from "../views/common/login";
import test from '../views/WechatConfiguration/Test'
import layout from "../views/layout/index";

import system from "./modules/system";
import basics from "./modules/basics";
import topic from "./modules/topic";
import order from "./modules/order";
import user from "./modules/user";
import app from "./modules/app";
import marriageGetName from "./modules/marriageGetName";// 婚姻取名
import wechat from "./modules/wechat";
import launch from "./modules/launch";
import WechatApplet from "./modules/WechatApplet";
import financial from "./modules/financial";
import vouchers from "./modules/voucher";
import complaint from "./modules/complaint";
import sku from "@router/modules/sku";
import course from "@router/modules/course";


Vue.use(VueRouter);


const routes =
    [
        {
            path: "/",
            name: "HOME",
            meta: {
                index: 0,
                title: "首页",

            },
            component: layout,
            redirect: {
                name: "HOME_INDEX",
            },
            children: system,
        },
        {
            path: "home_index",
            name: "HOME_INDEX",
            meta: {
                index: 0,
                title: "首页",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "HOME_CHLID",
            },
            children:[
                {
                    path: '/homechild',
                    name: "HOME_CHLID",
                    meta: {
                        index: 0,
                        title: "运营控制台",
                        isNav: false,
                    },
                    component: () => import('../views/homeInfo/logHome')
                },
                {
                    path: '/Launchchild',
                    name: "LAUNCH_CHLID",
                    meta: {
                        index: 0,
                        title: "投放控制台",
                        isNav: false,
                    },
                    component: () => import('../views/homeInfo/LaunchHome')
                },
                {
                    path: '/Financechild',
                    name: "FINANCE_CHLID",
                    meta: {
                        index: 0,
                        title: "财务控制台",
                        isNav: false,
                    },
                    component: () => import('../views/homeInfo/FinanceHome')
                },
            ]
        },
        {
            path: "/Launch",
            name: "LAUNCH",
            meta: {
                index: 0,
                title: "财务管理",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "CHANNEL_RECHARGE",
            },
            children: financial,
        },
        {
            path: "/Launch",
            name: "LAUNCH",
            meta: {
                index: 0,
                title: "投放管理",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "EVALUATION_PLAN_LIST",
            },
            children: launch,
        },
        {
            path: "/course",
            name: "COURSE",
            meta: {
                index: 0,
                title: "课程管理",
                isNav: false,
            },
            component: layout,
            children: course,
        },
        {
            path: "/WechatApplet",
            name: "WECHAT_APPLET",
            meta: {
                index: 0,
                title: "小程序管理",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "WECHAT_APPLET_LIST",
            },
            children: WechatApplet,
        },
        {
            path: "/basics",
            name: "BASICS",
            meta: {
                index: 0,
                title: "基础配置",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "COMMERCIAL_INFO",
            },
            children: basics,
        },
        {
            path: "/voucher",
            name: "VOUCHER",
            meta: {
                index: 0,
                title: "券管理",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "COMMERCIAL_INFO",
            },
            children: vouchers,
        },
        {
            path: "/SKU",
            name: "SKU",
            meta: {
                index: 0,
                title: "SKU管理",
                isNav: false,
            },
            component: layout,
            children: sku,
        },
        {
            path: "/wechat",
            name: "Wechat",
            meta: {
                index: 0,
                title: "微信公众号",
                isNav: false,
            },
            component: layout,
            // redirect: {
            //     name: "COMMERCIAL_INFO",
            // },
            children: wechat,
        },


        {
            path: "/app",
            name: "APP",
            meta: {
                index: 0,
                title: "应用管理",
                isNav: false,
            },
            component: layout,
            // redirect: {
            //     name: "COMMERCIAL_INFO",
            // },
            children: app,
        },
        {
            path: "/topic",
            name: "TOPIC",
            meta: {
                index: 0,
                title: "测评题库",
                isNav: false,
            },
            component: layout,
            // redirect: {
            //     name: "COMMERCIAL_INFO",
            // },
            children: topic,
        },
        {
            path: "/marriageName",
            name: "MARRIAGE_NAME",
            meta: {
                index: 0,
                title: "婚姻取名",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "babyMame",
            },
            children: marriageGetName,
        },
        {
            path: "/order",
            name: "ORDER",
            meta: {
                index: 0,
                title: "订单管理",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "TEST_ORDER",
            },
            children: order,
        },
        {
            path: "/user",
            name: "USER",
            meta: {
                index: 0,
                title: "用户管理",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "USER_LIST",
            },
            children: user,
        },
        {
            path: "/complaint",
            name: "COMPLAINT",
            meta: {
                index: 0,
                title: "投诉管理",
                isNav: false,
            },
            component: layout,
            redirect: {
                name: "COMPLAINT_LIST",
            },
            children: complaint,
        },

        {
            path: "/login",
            name: "LOGIN",
            meta: {
                index: 1,
                title: "登录",
                isNav: false,
            },
            component: login,
        },
        {
            path: "/test",
            name: "test",
            meta: {
                index: 1,
                title: "海报",
                isNav: false,
            },
            component: test,
        },


    ];

const router = new VueRouter({
    mode: 'history',
    routes,
});





export default router;

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

